import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.12.5/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.12.5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.12.5/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useAtom } from "jotai";
import { USER_SYSTEM_API } from "@constants/api";
import { backendRequest } from "@utils/common/backendRequest";
import { redirectUserOnMount } from "@utils/routing";
import { selectInitialProjectMutator, updateInitialDataMutator } from "@store/mutators/user";
import { cliLoginUserKeyAtom } from "@store/atoms/global/cliToken";
import { resolvePathToBackendURI } from "@utils/common/url";
import { RequestMethod } from "@types/RequestOptions";
/*
	Two scenarios to check for
	- When data is loaded on Mount and passed externally
	- How redirection is working

	Later :- Can add function to fetchData. Instead of direct use effect
 */

export function loadUserDataAndRedirect(_ref) {
  var _this = this;

  var _ref$fetchData = _ref.fetchData,
      fetchData = _ref$fetchData === void 0 ? true : _ref$fetchData,
      _ref$userAndSystemDat = _ref.userAndSystemData,
      userAndSystemData = _ref$userAndSystemDat === void 0 ? null : _ref$userAndSystemDat;
  var router = useRouter();

  var _useAtom = useAtom(updateInitialDataMutator),
      _useAtom2 = _slicedToArray(_useAtom, 2),
      updateInitialData = _useAtom2[1];

  var _useAtom3 = useAtom(selectInitialProjectMutator),
      _useAtom4 = _slicedToArray(_useAtom3, 2),
      selectInitialProject = _useAtom4[1];

  var _useState = useState(false),
      dataLoaded = _useState[0],
      setDataLoaded = _useState[1];

  var _useAtom5 = useAtom(cliLoginUserKeyAtom),
      _useAtom6 = _slicedToArray(_useAtom5, 2),
      loginKey = _useAtom6[0],
      setLoginKey = _useAtom6[1];

  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _dataToConsider;

      var dataToConsider;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dataToConsider = null;

              if (!fetchData) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return backendRequest(USER_SYSTEM_API, {});

            case 4:
              dataToConsider = _context.sent;
              _context.next = 10;
              break;

            case 7:
              if (!(userAndSystemData === null)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return");

            case 9:
              dataToConsider = userAndSystemData;

            case 10:
              updateInitialData(dataToConsider);

              if (!!((_dataToConsider = dataToConsider) !== null && _dataToConsider !== void 0 && _dataToConsider.userData)) {
                selectInitialProject(dataToConsider);
              }

              if (!(loginKey && loginKey !== "null" && dataToConsider.isUserLoggedIn)) {
                _context.next = 16;
                break;
              }

              backendRequest(resolvePathToBackendURI("/cli/actions/login.user"), {
                method: RequestMethod.POST,
                payload: {
                  loginKey: loginKey
                }
              }).then(function (res) {
                setLoginKey(null);
                window.location.href = "/login_sucessful";
              })["catch"](function (err) {
                if (err.message.includes("Invalid login key")) {
                  setLoginKey(null);
                  redirectUserOnMount(dataToConsider, router, setDataLoaded.bind(_this, true));
                }
              });
              _context.next = 18;
              break;

            case 16:
              _context.next = 18;
              return redirectUserOnMount(dataToConsider, router, setDataLoaded.bind(_this, true));

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, [userAndSystemData]);
  return [dataLoaded];
}